import { Toaster } from '@data-delivery/d3s';
import { useConfig } from '@data-delivery/permission-ui-shared-environment';
import { ThemeProvider, useTheme } from '@data-delivery/permission-ui-shared-ui';
import { TitleProvider } from '@data-delivery/title';
import { AppRouter } from './app-routes';

function AppContent() {
  const { VITE_CLIENT_ID } = useConfig();
  const { config } = useTheme();

  const d3sTheme = config.mode;

  if (!VITE_CLIENT_ID) {
    return null;
  }

  return (
    <>
      <Toaster theme={d3sTheme} richColors closeButton />
      <TitleProvider defaultSuffix=' | PCSFTP Permissioning UI'>
        <span style={{ display: 'none' }} />
      </TitleProvider>
      <AppRouter />
    </>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}
